import { queryOptions } from '@tanstack/react-query'

import { adminFapiUserManagement } from '@/services/admin'
import { shouldRetryRequest } from '@/libs/utils/errorUtils'

const QUERY_CONFIG = {
  STALE_TIME: 5 * 60 * 1000,
  GC_TIME: 10 * 60 * 1000,
} as const

export const userDetailQueries = {
  all: ['userManagement'] as const,

  details: () => [...userDetailQueries.all, 'detail'] as const,
  detail: (userId: string) =>
    queryOptions({
      queryKey: [...userDetailQueries.details(), userId] as const,
      queryFn: async () => adminFapiUserManagement.getUserDetailsById(userId),
      staleTime: QUERY_CONFIG.STALE_TIME,
      gcTime: QUERY_CONFIG.GC_TIME,
      retry: shouldRetryRequest,
    }),

  invitations: () => [...userDetailQueries.all, 'invitation', 'detail'] as const,
  invitation: (invitationId: string) =>
    queryOptions({
      queryKey: [...userDetailQueries.invitations(), invitationId] as const,
      queryFn: async () => adminFapiUserManagement.getInvitedUserDetailsById(invitationId),
      staleTime: QUERY_CONFIG.STALE_TIME,
      gcTime: QUERY_CONFIG.GC_TIME,
      retry: shouldRetryRequest,
    }),
}
